import { NotificationCounter, NotificationCounterVariant } from '@televet/kibble-ui';
import React from 'react';

const NewTaskNotificationDot = (): JSX.Element => {
  return (
    <NotificationCounter
      variant={NotificationCounterVariant.Green}
      size="xs"
      position="absolute"
      top="2px"
      right="4px"
    />
  );
};

export default NewTaskNotificationDot;
